module.exports = __webpack_public_path__ + "static/media/Cpp.f278be79.png";